import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[a7MatMenuTemplate]',
    standalone: false
})
export class MatMenuTemplateDirective {
  constructor(public template: TemplateRef<{ $implicit: any }>) {}
}
